<template>
   <div id="app">
    <router-view></router-view>
    <!-- 如果不同路由渲染同一组件，会导致数据不更新，这时候可以巧妙的加一个不同的Key -->
    <!-- <router-view :key="$route.fullpath"></router-view> -->
  </div>
</template>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: SOURCEHANSANSCN-REGULAR ,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  #app {
    height: 100%;
  }
}
// #app {
//   margin: 0;
//   padding: 0;
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   // text-align: center;
//   // color: #2c3e50;
// }
input {
  outline: none;
}
.screen_full {
  position: fixed;
  z-index: 99;
  right: 30px;
  top: 16px;
  cursor: pointer;
}
</style>
